import React, { FC } from 'react'
import { Spinner } from 'react-bootstrap'

interface LoaderProps {
  loading?: boolean
}

const Loader: FC<LoaderProps> = ({ loading = false }) => {
  return (
    <>
      {loading && (
        <h4 className="mx-auto mt-5 w-25 text-center text-secondary">
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
          Načítání...
        </h4>
      )}
    </>
  )
}

export default Loader
